(function(){
    'use strict';

    angular
        .module('appback')
        .controller('ImportController', ImportController);

    ImportController.$inject = ["$http", "$uibModal", "$log","$timeout","GenerallabService"];

    function ImportController($http, $uibModal, $log,$timeout,GenerallabService) {
        var vm = this;

        // ── estado ──────────────────────────────────
        vm.fichero   = null;
        vm.uploading = false;
        vm.errorFich = false;

        // ── captura el fichero del input ─────────────
        
        // ── abre el modal con el resultado ───────────
        function _abrirModal(ok, datos) {
            $uibModal.open({
                templateUrl : 'modalImport.html',
                controller  : 'ModalImportCtrl',
                controllerAs: 'vm',
                size        : 'md',
                resolve     : {
                    resultado: function() { return { ok: ok, datos: datos }; }
                }
            });
        }
        vm.popupInclinic = "";
       vm.abrirModalImport = function() {
            vm.popupImport = $uibModal.open({
                templateUrl: 'modalImport.html',
                controller: function($scope, $http) {
                    $scope.fichero   = null;
                    $scope.errorFich = false;
                    $scope.uploading = false;
                    $scope.generalLab = GenerallabService;

                    $scope.filtros = {
                    };

                    $scope.cerrar = function() {
                        vm.popupImport.close();
                    };

                    $scope.onFicheroChange = function(file) {
                        console.log("onficherochange");
                        $timeout(function() {
                            $scope.fichero   = file;
                            $scope.errorFich = false;
                        });
                    };

                    $scope.importarCodigos = function() {
                        $scope.uploading = true;
                        var fd = new FormData();
                        fd.append('filtros',angular.toJson($scope.filtros));
                        fd.append('codigos',angular.toJson($scope.codigos));
                        $http({
                            method          : 'POST',
                            url             : '/backend/inclinicinventario/importarcodigos',
                            data            : fd,
                            transformRequest: angular.identity,
                            headers         : { 'Content-Type': undefined }
                        })
                        .then(function(res)  {
                            window.location.reload();
                            //vm.popupImport.close();
                        })
                        .catch(function(err) {
                            console.error('Error', err);
                        })
                        .finally(function() {
                            $scope.uploading = false;
                        });
                    };

                    $scope.importar = function() {
                        if (!$scope.fichero) { $scope.errorFich = true; return; }

                        $scope.uploading = true;
                        var fd = new FormData();
                        fd.append('fichero', $scope.fichero);
                        fd.append('filtros',angular.toJson($scope.filtros));

                        $http({
                            method          : 'POST',
                            url             : '/backend/inclinicinventario/importar',
                            data            : fd,
                            transformRequest: angular.identity,
                            headers         : { 'Content-Type': undefined }
                        })
                        .then(function(res)  {
                            $scope.codigos = res.data.codigos;
                            console.log('OK', res.data);
                            //vm.popupImport.close();
                        })
                        .catch(function(err) {
                            console.error('Error', err);
                        })
                        .finally(function() {
                            $scope.uploading = false;
                        });
                    };
                },
                size: 'md'
            });
        };
    }

})();